var _defs, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#01663e;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 20,
    cy: 20,
    r: 19.53
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.34,25.56l3.1,2.84a1.18,1.18,0,0,0,.8.31h0a1.28,1.28,0,0,0,.84-.31l3.29-2.84h6.89v.21S24,32.74,21,33.29a6.12,6.12,0,0,1-3.86-.18c-1.87-.82-8.78-7.55-8.78-7.55Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33.48,13.9a1.2,1.2,0,0,1-1.2,1.2,1.17,1.17,0,0,1-.64-.19l-4.24,6,3,2.83h-7.5l-3.08,2.88a.63.63,0,0,1-.45.18.74.74,0,0,1-.51-.2l-3.12-2.88-7.25,0L11.38,21l-3.05-6.9a1.25,1.25,0,0,1-.54.12,1.27,1.27,0,1,1,0-2.54,1.29,1.29,0,0,1,1.21,1.37,1.24,1.24,0,0,1-.09.39c.68.42,4.3,2.63,4.37,2.63s3.87-1.24,3.87-1.24l2-5.93a1.26,1.26,0,1,1,1,0L22.36,15,26,16.6l5.14-2.23a1.27,1.27,0,0,1-.09-.47,1.2,1.2,0,0,1,2.4,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/logo1.dcbb19bd2240c25332245897b0a1e25f.svg";
export { ForwardRef as ReactComponent };